// GeofenceChip.js — GPS geofence status indicator
import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckIcon,
  LocationOff as NoGpsIcon,
  LocationOn as GpsIcon,
} from '@mui/icons-material';

/**
 * @param {object|null} geofenceStatus - { distance, nearestZone, inside }
 * @param {boolean} gpsLoading - GPS currently fetching
 * @param {string|null} gpsError - GPS error message
 */
export default function GeofenceChip({ geofenceStatus, gpsLoading, gpsError }) {
  if (gpsLoading) {
    return (
      <Chip
        icon={<GpsIcon sx={{ fontSize: 12 }} />}
        label="Locating..."
        size="small"
        variant="outlined"
        sx={{ height: 20, fontSize: '0.65rem' }}
      />
    );
  }

  if (gpsError || !geofenceStatus) {
    return (
      <Chip
        icon={<NoGpsIcon sx={{ fontSize: 12 }} />}
        label="No GPS"
        size="small"
        color="default"
        variant="outlined"
        sx={{ height: 20, fontSize: '0.65rem' }}
      />
    );
  }

  const { distance, nearestZone, inside } = geofenceStatus;

  if (inside === null || distance === null) {
    return (
      <Chip
        icon={<NoGpsIcon sx={{ fontSize: 12 }} />}
        label="GPS unavailable"
        size="small"
        color="default"
        variant="outlined"
        sx={{ height: 20, fontSize: '0.65rem' }}
      />
    );
  }

  if (inside) {
    return (
      <Chip
        icon={<CheckIcon sx={{ fontSize: 12 }} />}
        label={nearestZone ? `${nearestZone.name} (${distance}m)` : `In zone (${distance}m)`}
        size="small"
        color="success"
        variant="outlined"
        sx={{ height: 20, fontSize: '0.65rem' }}
      />
    );
  }

  // Outside — check if near (within 2x radius)
  const nearThreshold = nearestZone ? (nearestZone.radius_m || 200) * 2 : 400;
  const isNear = distance <= nearThreshold;

  return (
    <Chip
      icon={isNear ? <GpsIcon sx={{ fontSize: 12 }} /> : <NoGpsIcon sx={{ fontSize: 12 }} />}
      label={isNear ? `Near ${nearestZone?.name || 'zone'} (${distance}m)` : `Outside geofence (${distance}m)`}
      size="small"
      color={isNear ? 'warning' : 'error'}
      variant="outlined"
      sx={{ height: 20, fontSize: '0.65rem' }}
    />
  );
}
